import { useState } from "react";
import { categories, comics } from "@/mocks/comics";

export default function Featured() {
  const [active, setActive] = useState(categories[0]);
  const filtered =
    active === "全部" ? comics : comics.filter((c) => c.category === active);

  return (
    <section id="featured" className="bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-sm font-bold uppercase tracking-widest text-secondary-600">
              萌系推荐
            </span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
              人气软萌治愈作品
            </h2>
            <p className="mt-3 max-w-xl text-foreground-700">
              从软萌画风到温馨剧情，按你的口味挑一部治愈系漫画清单中的心头好。
            </p>
          </div>
          <a
            href="#healing"
            className="whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-bold text-primary-700 ring-1 ring-primary-300 transition-colors hover:bg-primary-100"
          >
            查看完整治愈清单
            <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat}
              type="button"
              onClick={() => setActive(cat)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === cat
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-700 ring-1 ring-background-200 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {filtered.map((comic) => (
            <article
              key={comic.id}
              className="group flex flex-col overflow-hidden rounded-2xl bg-background-50 ring-1 ring-background-200 transition-shadow hover:shadow-soft"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={comic.cover}
                  alt={`${comic.title}漫画封面插画`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50">
                  <i className="ri-heart-3-fill text-xs"></i>
                  {comic.rating}
                </span>
                <span className="absolute bottom-3 right-3 rounded-full bg-foreground-950/60 px-3 py-1 text-xs text-background-50 backdrop-blur">
                  {comic.status}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-lg text-foreground-950">
                  {comic.title}
                </h3>
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {comic.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600 line-clamp-3">
                  {comic.intro}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">
                    {comic.chapters}
                  </span>
                  <a
                    href="#spotlight"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-primary-600 transition-colors hover:text-primary-700"
                  >
                    看亮点
                    <i className="ri-arrow-right-up-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}